/**
 * @generated SignedSource<<a87102d9f3ddd88b37157276c5230ac2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowPanelInner_ChatMessage_conversation$data = {
  readonly note: {
    readonly __typename: string;
    readonly id: string;
  } | null;
  readonly " $fragmentType": "AskFellowPanelInner_ChatMessage_conversation";
};
export type AskFellowPanelInner_ChatMessage_conversation$key = {
  readonly " $data"?: AskFellowPanelInner_ChatMessage_conversation$data;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ChatMessage_conversation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AskFellowPanelInner_ChatMessage_conversation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AskCopilotConversation",
  "abstractKey": null
};

(node as any).hash = "678d63c69ea4fd4f463ec931f0f5c99e";

export default node;
